
const { operators } = window.fvGlobalVar;
const i18n = window.fvGlobalVar?.i18n;

export const getOperators = () => [
	{
		key: 'OR',
		value: i18n?.or,
		icon: '',
	},
	{
		key: 'AND',
		value: 'AND',
		icon: '',
	},
];

export const getStatusFilter = (selected) => [
	{
		key: 'read',
		value: i18n?.read,
		icon: '',
	},
	{
		key: 'unread',
		value: i18n?.unread,
		icon: '',
	},
	{
		key: 'spam',
		value: i18n?.spam,
		icon: '',
	},
];

export const getConditionColumns = (columns) =>
	columns
		?.filter(
			(column) => column.colKey !== 'captured' && column.colKey !== 'fv_status'
		)
		?.map((column) => ({
			key: column.colKey,
			value: column.alias,
			icon: '',
		}));

export const getConditionOperators = () => operators;
// export const getConditionOperators = () => [
// 	{
// 		key: 'equal',
// 		value: 'Equal',
// 		icon: '',
// 	},
// 	{
// 		key: 'not_equal',
// 		value: 'Not Equal',
// 		icon: '',
// 	},
// 	{
// 		key: 'contain',
// 		value: 'Contain',
// 		icon: '',
// 	},
// 	{
// 		key: 'not_contain',
// 		value: 'Not Contain',
// 		icon: '',
// 	},
// ];
